export function getDisplayLoanName(loanName: string): string {
    return loanName
}
